import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import MenuIcon from "@mui/icons-material/Menu";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Toolbar from "@mui/material/Toolbar";
import LogoutIcon from "@mui/icons-material/Logout";
import user_profile from "../../assets/user_profile.svg";
import logo_blue from "../../assets/logo_blue.svg";
import HomeIcon from "@mui/icons-material/Home";
import SettingsIcon from "@mui/icons-material/Settings";
import { AppBar, IconButton, Typography } from "@mui/material";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import "../Admin/AdminPage.css";
import ListIcon from "@mui/icons-material/List";
import useLogout from "../../hooks/useLogout";

const drawerWidth = 260;

function MemberPage(props) {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const navigate = useNavigate();
  const logout = useLogout();
  let params = useParams();

  useEffect(() => {
    let url = Object.values(params)[0];

    if (url.includes("home")) {
      setSelectedIndex(0);
    }
    if (url.includes("events")) {
      setSelectedIndex(1);
    }
  }, []);

  const logoutHandler = async () => {
    await logout();
    navigate("/");
  };

  const drawer = (
    <div>
      <Toolbar style={{ paddingLeft: "12px", paddingBottom: "10px" }}>
        <div className="home">
          <img
            src={logo_blue}
            alt=""
            height="60px"
            width="180px"
            className="logo_image"
          />
          <div
            style={{ display: "flex", alignItems: "center", marginTop: "10px" }}
          >
            <img
              className="profile"
              src={user_profile}
              alt=""
              width="60px"
              height="60px"
              style={{ marginTop: "14px", marginRight: "14px", padding: "0px" }}
            />
            <label>
              <h3 style={{ marginBottom: "0px" }}>
                <strong style={{ textTransform: "capitalize" }}>
                  {localStorage.getItem("user_name")}
                </strong>
              </h3>
              <p style={{ marginTop: "0px" }}>{"Client"}</p>
            </label>
          </div>
        </div>
      </Toolbar>
      <Divider />
      <List disablePadding>
        <ListItemButton
          style={{
            background: selectedIndex === 0 ? "#21b3d8" : "",
            color: selectedIndex === 0 ? "white" : "",
          }}
          onClick={() => {
            navigate("home");
            setSelectedIndex(0);
          }}
        >
          <ListItemIcon
            style={{
              color: selectedIndex === 0 ? "white" : "",
            }}
          >
            <HomeIcon />
          </ListItemIcon>
          <ListItemText primary="Home" />
        </ListItemButton>
        <ListItemButton
          style={{
            background: selectedIndex === 1 ? "#21b3d8" : "",
            color: selectedIndex === 1 ? "white" : "",
          }}
          onClick={() => {
            navigate("events");
            setSelectedIndex(1);
          }}
        >
          <ListItemIcon
            style={{
              color: selectedIndex === 1 ? "white" : "",
            }}
          >
            <ListIcon />
          </ListItemIcon>
          <ListItemText primary="Events" />
        </ListItemButton>

        {/* <ListItemButton onClick={() => navigate("settings")}>
          <ListItemIcon>
            <SettingsIcon />
          </ListItemIcon>
          <ListItemText primary="Settings" />
        </ListItemButton> */}
      </List>

      <Divider />
      <List>
        <ListItem disablePadding>
          <ListItemButton onClick={logoutHandler}>
            <ListItemIcon style={{ color: "red" }}>
              <LogoutIcon />
            </ListItemIcon>
            <ListItemText primary="Logout" style={{ color: "red" }} />
          </ListItemButton>
        </ListItem>
      </List>
    </div>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
        }}
      >
        <Toolbar style={{ backgroundColor: "white", color: "black" }}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: "none" } }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap component="div">
            Home
          </Typography>
        </Toolbar>
      </AppBar>

      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        <Drawer
          style={{ paddingLeft: "8px" }}
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", sm: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
      <Box
        style={{ marginTop: "50px" }}
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
        }}
      >
        <Outlet />
        <Toolbar />
      </Box>
    </Box>
  );
}

MemberPage.propTypes = {
  window: PropTypes.func,
};

export default MemberPage;
